import { SafelyRenderHtml } from '@src/services/renderEditorText';
import { isAgent360 } from '@src/utils/isAgent360';
import { isArs } from '@src/utils/isArs';

const productTitle = (product, { noHtml = false } = {}) => {
    const isAgent = isAgent360(product.name) && (product.platform === 'agent360' || product.platform === 'foremost 5.0');

    if (noHtml) {
        if (isAgent) {
            return `${product.name} (Agent360)`;
        }

        if (isArs(product.name)) {
            return `${product.name} (ARS)`;
        }

        if (product.name === 'Take 20') {
            return 'Reimagine Foremost Virtual Events';
        }

        return product.name;
    }

    if (isAgent) {
        return SafelyRenderHtml(`${product.name} (Agent360)`);
    }

    if (isArs(product.name)) {
        return SafelyRenderHtml(`${product.name} (ARS)`);
    }

    if (product.name === 'Take 20') {
        return SafelyRenderHtml('Reimagine Foremost Virtual Events');
    }

    return product.name;
};

export { productTitle };
